(function()
{
	//Import classes
	var Application = include("springroll.Application");
	var Button = include("springroll.pixi.Button");
	var Container = include("PIXI.Container");
	var Debug = include("springroll.Debug", false);
	var MovieClip = include("PIXI.extras.MovieClip");
	var Sprite = include("PIXI.Sprite");
	var ButtonSounds = include("springroll.ButtonSounds");
	var Texture = include("PIXI.Texture");

	/**
	 * Panel contains all of the visual elements for the title state
	 * @class nature.TitlePanel
	 * @extends springroll.easeljs.BasePanel
	 */
	var TitlePanel = function()
	{
		Container.call(this);
	};

	//Extend the base panel
	var s = Container.prototype;
	var p = extend(TitlePanel, Container);

	/**
	 * Setup the state, this happens on each state entering
	 */
	p.setup = function()
	{
		this.background = new Sprite(Texture.fromImage("TitleBG"));
		this.background.interactive = true;
		this.background.buttonMode = true;
		this.addChild(this.background);

		this.playButton = new Button(
		{
			up: "playButton_up",
			over: "playButton_over",
			down: "playButton_down"
		});
		this.addChild(this.playButton);

		this.buttonSounds = new ButtonSounds("ButtonSelect", "ButtonRollover", this.playButton);
	};

	/**
	 * Un-setup the panel when exiting the state
	 */
	p.teardown = function()
	{
		this.removeChildren();
		this.buttonSounds.destroy();

		this.background = null;
		this.playButton = null;
	};

	//Assign to namespace
	namespace('nature').TitlePanel = TitlePanel;
}());
